import type { ErrorComponentProps } from "@tanstack/react-router";
import "./styles.css";

export const DefaultCatchBoundary = ({ error }: ErrorComponentProps) => {
  return (
    <div className="error-container">
      {/* Animated background elements */}
      <div className="error-background-wrapper">
        <div className="error-bg-overlay"></div>
        <div className="error-blob-1"></div>
        <div className="error-blob-2"></div>

        {/* Glitch lines */}
        <div className="glitch-line-1"></div>
        <div className="glitch-line-2"></div>
        <div className="glitch-line-3"></div>
      </div>

      <div className="error-content-wrapper">
        {/* 500 Number with glitch effect */}
        <div className="error-number-container">
          <h1 className="error-number-500">500</h1>
          <div className="error-circle-overlay">
            <div className="error-circle-inner">
              {/* <AlertTriangle className='w-12 h-12 md:w-16 md:h-16 text-white/80 animate-pulse' /> */}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="error-text-content">
          <h2 className="error-title">System Overload</h2>
          <p className="error-description">
            Houston, we have a problem! Our servers are experiencing some
            technical difficulties. Our engineers are working hard to fix this
            issue.
          </p>

          {/* Status message */}
          <div className="error-status-box">
            <p className="error-status-text">
              <span className="error-status-indicator"></span>
              Error Code: 500 - {error.message || "Internal Server Error"}
            </p>
          </div>

          {/* Help text */}
          <p className="error-help-text">
            If this problem persists, please contact our support team.
          </p>
        </div>

        {/* Floating warning elements */}
        <div className="warning-box-1"></div>
        <div className="warning-box-2"></div>
        <div className="warning-dot"></div>
      </div>
    </div>
  );
};
